import { api } from "@/builders/axios";
import { UniqueLinkData } from "../types/unique-link";

const get = function (unique_link: string) {
  return api
    .get<{
      data: UniqueLinkData;
    }>(`data/unique-links/${unique_link}`)
    .then((res) => res.data);
};

export const unique_links = {
  get,
};
